import { Component } from '@angular/core';
import { Subject } from 'rxjs';
import { SessionService } from '../../../Util/Session/session.service';
import { ComboService } from '../../../Model/Combo/combo.service';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { NgbModal, NgbModalOptions, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import { DataTablesModule } from 'angular-datatables';
import { EmployeeReportingToService } from '../../../Model/ReportingToService/employee-reporting-to.service';
import { ConfirmationComponent } from '../../../Component/Confirmation/confirmation/confirmation.component';
import { CommonService } from '../../../Model/Common/common.service';
import { EmployeeToDefaultApplyComponent } from '../employee-to-default-apply/employee-to-default-apply.component';

@Component({
  selector: 'app-employee-to',
  standalone: true,
  imports: [NgbModule, FormsModule, ReactiveFormsModule, NgSelectModule, CommonModule, DataTablesModule],
  templateUrl: './employee-to.component.html',
  styleUrl: './employee-to.component.scss'
})
export class EmployeeToComponent {
  isDisabled: boolean = false;
  dtTrigger: Subject<any> = new Subject<any>();
  public User: any = null;
  EmployeeType: string = 'Front';
  BranchMaster: any[] = [];
  ClientLoad: any[] = [];
  SiteLoad: any[] = [];
  BranchId: any = null;
  BranchName: string = '';
  ClientId: any = null;
  ClientName: string = '';
  SiteId: any = null;
  SiteName: string = '';
  SiteCode: string = '';
  EmployeeCode: string = '';
  ReportingToData: any[] = [];
  UserLoad: any[] = [];
  DepartmentLoad: any[] = [];
  Shift: any[] = [];
  getSessionData: any[] = [];
  allSelect: boolean = false;
  dtoptions: DataTables.Settings = {};
  constructor(
    private sessionService: SessionService,
    private comboload: ComboService,
    private toast: ToastService,
    private modalService: NgbModal,
    private EmployeeService: EmployeeReportingToService,
    protected common: CommonService
  ) {
    this.common.getPageRights();
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.ComboLoad('GetEssDepartmentMaster');
    this.ComboLoad('Branch');
    this.ComboLoad('GetEssUserMaster');
    this.ComboLoad('shift');
  }
  onSelectionChange(type: string, event: any) {
    if (type == 'EmployeeType') {
      this.EmployeeType = event.target.value;
      this.ReportingToData = [];
      this.ClientId = null;
      this.ClientName = ''
      this.SiteCode = ''
      this.SiteName = ''
      this.SiteId = null

    }
  }
  onSelectChange(type: string) {
    if (type === 'Branch') {
      const selected = this.BranchMaster.find(duty => duty.BranchMasterID === this.BranchId);
      this.BranchName = selected ? selected.BranchName : null;
      this.ClientId = null;
      this.ClientName = ''
      this.SiteCode = ''
      this.SiteName = ''
      this.SiteId = null
      this.ReportingToData = [];
    }
    else if (type == 'Client') {
      const selected = this.ClientLoad.find(site => site.ClientGroupMasterID === this.ClientId);
      this.ClientName = selected ? selected.ClientGroupName : null;
      this.SiteCode = ''
      this.SiteName = ''
      this.SiteId = null
      this.ReportingToData = [];
    }
    else if (type === 'Site') {
      const selected = this.SiteLoad.find(duty => duty.SiteMasterID === this.SiteId);
      this.SiteName = selected ? selected.SiteName : null;
      this.SiteCode = selected ? selected.SiteCode : null;
      this.ReportingToData = [];
    }
  }
  ComboLoad(Combotype: String, Combotype2: string = '', index = 0) {
    this.comboload.ComboLoad({
      'Combotype': Combotype,
      'BranchId': (Combotype == 'Client' || Combotype == 'Site' || Combotype == 'Designation' || Combotype == 'Duty') ? this.BranchId : 0,
      'ClientId': (Combotype == 'Site' || Combotype == 'Designation' || Combotype == 'Duty') ? this.ClientId : 0,
      'SiteId': (Combotype == 'Designation' || Combotype == 'Duty') ? this.SiteId : 0,

    }).subscribe({
      next: (response) => {
        if (Combotype == 'Branch') {
          this.BranchMaster = response.ComboLoad;
        } else if (Combotype == 'Client') {
          this.ClientLoad = response.ComboLoad;
        } else if (Combotype == 'Site') {
          this.SiteLoad = response.ComboLoad;
        } else if (Combotype == 'GetEssUserMaster') {
          this.UserLoad = response.ComboLoad;
        } else if (Combotype == 'GetEssDepartmentMaster') {
          this.DepartmentLoad = response.ComboLoad;
        } else if (Combotype == 'shift') {
          this.Shift = response.ComboLoad;
        }
      },
      complete: () => {
      },
      error: (error) => {
      },
    });
  }
  Search() {
    if (!this.BranchName || this.BranchName == '' || this.BranchId == 0) {
      this.toast.show({ message: 'Please select Branch!', type: toastTypeEnum.warning });
      return;
    }
    this.isDisabled = true;
    const ReportingToData = {
      SelectType: 'reportingtoemployee',
      BranchID: this.BranchId,
      ClientID: this.EmployeeType == 'Back' ? 0 : this.ClientId,
      SiteID: this.EmployeeType == 'Back' ? 0 : this.SiteId,
      EmpCode: this.EmployeeCode == '' ? '0' : this.EmployeeCode,
      EmpType: this.EmployeeType
    }
    this.EmployeeService.EmployeeReportingToSelect(ReportingToData).subscribe(
      data => {
        if (data.Table && data.Table.length > 0) {
          this.ReportingToData = Object.values(data.Table);
          this.ReportingToData.forEach((item) => {
            item.DepartmentID === 0 ? item.DepartmentID = null : item.DepartmentID;
            item.ReportingManagerId1 === 0 ? item.ReportingManagerId1 = null : item.ReportingManagerId1;
            item.ReportingManagerId2 === 0 ? item.ReportingManagerId2 = null : item.ReportingManagerId2;
            item.ShiftMasterID === 0 ? item.ShiftMasterID = null : item.ShiftMasterID;
          })
        } else {
          this.toast.show({ message: 'No data found', type: toastTypeEnum.warning });
          this.ReportingToData = [];
        }
        //this.ReportingToData = Object.values(data.Table);
        this.isDisabled = false;
      },
      error => {
        console.error('Error:', error);
        this.isDisabled = false
      }
    );
  }

  async save() {
    await this.common.getPageRights();
    const modalRef = this.modalService.open(ConfirmationComponent, {
      size: 'md',
      backdrop: 'static',
      windowClass: 'confirmation-modal'
    });

    modalRef.componentInstance.Message = 'Are you Sure want to save?'

    modalRef.result.then((result: any) => {
      if (result) {
        if (this.common.PageRight.IsEdit) {
          this.Update();
        }
      }
    }).catch(() => {

    });
  }

  Update() {
    if (this.ReportingToData.length === 0) {
      this.toast.show({ message: 'No Data Available!', type: toastTypeEnum.warning });
      return
    }
    for (let i = 0; i < this.ReportingToData.length; i++) {
      const rt = this.ReportingToData[i];
      const managerId1 = parseInt(rt.ReportingManagerId1, 10);
      const managerId2 = parseInt(rt.ReportingManagerId2, 10);

      if (managerId1 === managerId2 && managerId1 > 0) {
        this.toast.show({ message: `Both the Reporting Approval cannot be same for Employee Code: ${rt.EmpCode}`, type: toastTypeEnum.danger });
        return;
      }
      if (managerId1 === 0 && managerId2 > 0) {
        this.toast.show({ message: `Please select Reporting Approval1 for Employee Code: ${rt.EmpCode}`, type: toastTypeEnum.danger });
        return;
      }
    }
    this.User = this.sessionService.GetUserDetails();
    const Data = this.ReportingToData.map(rt => {
      return {
        EmployeeMasterID: rt.EmpMasterID,
        BranchID: rt.Branch,
        SiteID: rt.SiteMasterID,
        EmpType: rt.EmpType,
        ReportingmanagerId1: rt.ReportingManagerId1,
        ReportingmanagerId2: rt.ReportingManagerId2,
        DepartmentMasterID: rt.DepartmentID,
        ShiftMasterID: rt.ShiftMasterID
      };
    });
    console.log(Data)
    const ReportData = {
      SelectType: 'Update',
      ESS_EmployeeReportingTo: Data,
      UserId: this.User.UserId
    }

    this.isDisabled = true;
    this.EmployeeService.ReportingToEmployee(ReportData).subscribe(
      data => {
        if (data.Error_Code == 1) {
          this.toast.show({ message: data.Error_Message, type: toastTypeEnum.success });
          this.ReportingToData = []
        }
        else {
          this.toast.show({ message: data.Error_Message, type: toastTypeEnum.warning });
        }
        this.isDisabled = false;
        this.Search();
      },
      error => {
        console.error('Error:', error);
        this.isDisabled = false;
      });
  }
  DefaultToAll() {
    this.isDisabled = true;
    const modalOptions: NgbModalOptions = {
      centered: true,
      backdrop: 'static',
      size: 'lg'
    };
    const modalRef = this.modalService.open(EmployeeToDefaultApplyComponent, modalOptions);
    modalRef.result.then((result) => {
      this.isDisabled = false;
      if (result.ApplyTo == 'all') {
        console.log(result);
        const storedUserData = result; //JSON.parse(sessionStorage.getItem('userData') || '{}');
        this.all(storedUserData);
      } else if (result.ApplyTo == 'selected') {
        const storedUserData = result;
        this.allSelected(storedUserData);
      }
    });
    this.isDisabled = false;
  }
  all(Data: any) {
    if (!Data || !Data.For || !Data.ID) {
      return;
    }
    for (let site of this.ReportingToData) {
      if (Data.For == 'User' && Data.ReportType == 'rp1') {
        site.ReportingManagerId1 = Data.ID;
      }
      else if (Data.For == 'User' && Data.ReportType == 'rp2') {
        site.ReportingManagerId2 = Data.ID;
      }
      else if (Data.For == 'Department') {
        site.DepartmentID = Data.ID;
      }
      else if (Data.For == 'Shift') {
        site.ShiftMasterID = Data.ID;
      }
    }
  }

  allSelected(Data: any) {
    if (!Data || !Data.For || !Data.ID) {
      return;
    }
    for (let site of this.ReportingToData) {
      if (Data.For == 'User' && Data.ReportType == 'rp1') {
        if(site.selected){
          site.ReportingManagerId1 = Data.ID;
        }
      }
      else if (Data.For == 'User' && Data.ReportType == 'rp2') {
        if(site.selected){
          site.ReportingManagerId2 = Data.ID;
        }
      }
      else if (Data.For == 'Department') {
        if(site.selected){
          site.DepartmentID = Data.ID;
        }
      }
      else if (Data.For == 'Shift') {
        if(site.selected){
          site.ShiftMasterID = Data.ID;
        }
      }
    }
  }

  onChange() {
    this.ReportingToData = [];
  }
  selectAll(event: any) {
    const isChecked = event.target.checked;
    for (let data of this.ReportingToData) {
      data.selected = isChecked;
    }
  }

  resetSelection() {
    for (let data of this.ReportingToData) {
      if (data.selected === false) {
        this.allSelect = false;
        return;
      }
    }
  }
}
